import React, { useEffect }  from "react";
import { useSelector  } from "react-redux";

import Routes from "./routes/routes";
import { APP_HEADER_NAME, TENANT_HEADER_NAME } from "./config/config.entry";

import { ThemeProvider } from "@material-ui/core/styles";
import { apps, muiTheme } from "./utils/muiTheme";
import { themeColors } from "./utils/themeColors";
import { useLocalStorage } from "./utils/proprietaryHooks";
import { loadRecaptcha } from "./utils/reCaptcha/recaptchaLoader";
import { getComponentConfigValue } from './config/parameterConfigs';

//class App extends Component {
const App = () => {
  const [name, setName] = useLocalStorage("_appName");
  var appName = "";
  var tenant = "";

  var request = new XMLHttpRequest();
  request.open("GET", document.location, false);
  request.send(null);
  appName = request.getResponseHeader(APP_HEADER_NAME);
  tenant = request.getResponseHeader(TENANT_HEADER_NAME);
  var titleAppName = appName;

  if (!appName || !themeColors[appName]) {
    appName = "ibuhoo";
  }
  if (name === undefined || name === null) {
    setName(appName);
  }
  if (tenant !== null && tenant !== undefined) {
    titleAppName = appName + "_" + tenant;
  }
  const title = apps.find((app) => app.name === titleAppName)?.title;
  document.title = title ? title : "GSE Suite";

  const parameterConfig = useSelector(
    (state) => state.applicationsReducer.parameterConfig
  );

  useEffect(() => {
    const shouldShowParameter = (appName, tenant, parameter) => {    
    const validateCaptcha = getComponentConfigValue(appName, tenant, parameter);
    if (validateCaptcha !== null){
      if (validateCaptcha === false){
        return false;
      }      
    }

    return parameterConfig?.captchaApply;
    };

    if (shouldShowParameter(appName, tenant, 'captchaApply')){
      loadRecaptcha()
      .then(() => console.log("reCAPTCHA v3 cargado"))
      .catch((err) => console.error("Error cargando reCAPTCHA", err));
    }    
  }, [appName, tenant, parameterConfig]);

  return (
    <ThemeProvider theme={muiTheme(appName, tenant)}>
      <Routes appName={appName} tenant={tenant}></Routes>
    </ThemeProvider>
  );
};

export default App;
